import NavigateNextIcon from "@mui/icons-material/NavigateNext"
import { CardActions, useTheme } from "@mui/material"
import { ReactElement } from "react"
import { useNavigate } from "react-router-dom"

import { LCTOnlyDatasets, recognisedLctDevices } from "../../../constants/enums"
import { TT_GO_TO_DEVICE_SUMMARY } from "../../../constants/tooltips"
import { SINGLE_DEMAND_DEVICE_NAV_LINK } from "../../../router/routes"
import { TDevicesToInstall } from "../../../services/middleware/mappers/dnoInterface/dnoApplicationsMapper"
import AppButton from "../../buttons/appButton"
import VerticalKeyValueList from "../../dataDisplay/verticalKeyValueList"
import AppTooltip from "../../helper/appTooltip"
import LctAvatar from "../../pills/lct/lctAvatar"
import { AppCard, AppCardHeader, AppCardContent } from "../../surfaces/appCard"

interface IDemandHpDatabaseDeviceProps {
    deviceReference: string
    deviceSysRef: string
    details: TDevicesToInstall
}

/**
 * Card for displaying details about an proposed demand heat pump device
 * at a property. Designed for use on the single application summary page.
 * This component has been designed to be schema version agnostic. It picks
 * of a number of core fields and ingests the rest via the generic `details`.
 * object. This is for heat pumps listed in the ENA heat pump database.
 */
const DemandHpDatabaseDevice = ({
    deviceReference,
    deviceSysRef,
    details,
}: IDemandHpDatabaseDeviceProps): ReactElement => {
    const navigate = useNavigate()
    const theme = useTheme()
    return (
        <AppCard
            sx={{ backgroundColor: theme.palette.background.contentBackground }}
        >
            <AppCardHeader
                title={deviceReference}
                subheader="Heat Pump"
                avatar={<LctAvatar lcts={[recognisedLctDevices.hp]} />}
            />
            <AppCardContent>
                <VerticalKeyValueList kwargs={details} />
            </AppCardContent>
            <CardActions sx={{ justifyContent: "flex-end" }}>
                <AppTooltip title={TT_GO_TO_DEVICE_SUMMARY}>
                    <AppButton
                        variant="outlined"
                        onClick={() =>
                            navigate(
                                SINGLE_DEMAND_DEVICE_NAV_LINK(
                                    LCTOnlyDatasets.HP,
                                    String(deviceSysRef)
                                )
                            )
                        }
                        endIcon={<NavigateNextIcon />}
                    >
                        View Device Details
                    </AppButton>
                </AppTooltip>
            </CardActions>
        </AppCard>
    )
}

export default DemandHpDatabaseDevice
